import React, { useState } from 'react';

import { Fab, Tooltip } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever
} from "@mui/icons-material";

import { 
  ASIFeature,
} from "@dndModels";
import { 
  ABILITY_SCORES_EXPANDED 
} from "@dndModels/Constants";
import { AbilityScoreExpandedType } from "@dndModels/Types";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
// import LoadingBox from '../../../../components/input/LoadingBox';

interface Props {
  obj: ASIFeature;
  onChange: (asi_feature: ASIFeature) => void; 
  onDelete: () => void; 
  disabled: boolean;
}

export interface State { 
  asi_feature: ASIFeature;
  loading: boolean;
}

export default function ASIFeatureInput({ 
  obj,
  disabled,
  onChange,
  onDelete 
}: Props) {
  const [ff, setFF] = useState(obj.clone());

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 2
        }}>
        { !disabled &&
          <Tooltip title={`Delete ASI Feature`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid
        size={{
          xs: 5
        }}>
        <StringBox
          name="Amount"
          value={`${ff.amount}`}
          type="number"
          disabled={disabled}
          onBlur={(value: string) => {
            const asi_feature = ff;
            const amount: number = +value;
            asi_feature.amount = amount;
            onChange(asi_feature);
            setFF(asi_feature);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 5
        }}>
        <SelectStringBox
          name="Options"
          options={ABILITY_SCORES_EXPANDED}
          values={ff.options}
          multiple
          disabled={disabled}
          onChange={(changed: AbilityScoreExpandedType[]) => {
            const asi_feature = ff;
            asi_feature.options = changed;
            onChange(asi_feature);
            setFF(asi_feature);
          }}
        />
      </Grid>
      { ff.options.includes("Selectable") &&
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Selectable Key"
            value={ff.selectable_key}
            disabled={disabled}
            onBlur={(changed: string) => {
              const asi_feature = ff;
              asi_feature.selectable_key = changed;
              onChange(asi_feature);
              setFF(asi_feature);
            }}
          />
        </Grid>
      }
    </Grid>
  );
}
